module.exports = "<ion-content>\n    <app-grid-movement [commonData]='objValues' *ngIf='show==\"grid\"'></app-grid-movement>\n</ion-content>"